import mixpanel from "mixpanel-browser";

// config
import config from "../../config";

mixpanel.init(config.MIXPANEL_V2);

const DX_APP = "DX App";

// let env_check = process.env.NODE_ENV === "production";
let env_check = true;

let actions = {
  identify: id => {
    if (env_check) mixpanel.identify(id);
  },
  alias: id => {
    if (env_check) mixpanel.alias(id);
  },
  track: (name, props) => {
    if (env_check)
      mixpanel.track(name, {
        app_name: DX_APP,
        ...props,
      });
  },
  people: {
    set: props => {
      if (env_check)
        mixpanel.people.set({
          app_name: DX_APP,
          ...props,
        });
    },
  },
};

export const Mixpanel = actions;

// mixpanel events, tags=conversion
export const MixpanelEvents = {
  page_viewed: "Page Viewed",
  page_depth_viewed: "Page Depth Viewed",
  contact_form_started: "Contact Form Started",
  contact_form_completed: "Contact Form Completed",
  contact_button_clicked: "Contact Button Clicked",
  video_playback_started: "Video Playback Started",
  video_playback_completed: "Video Playback Completed",
  video_playback_paused: "Video Playback Paused",
  video_playback_resumed: "Video Playback Resumed",
  page_exit: "Page Exit",
  quiz_button_clicked: "Quiz Button Clicked",
  quiz_answers_completed: "Quiz Answers Completed",
  quiz_form_opened: "Quiz Form Opened",
  quiz_form_completed: "Quiz Form Completed",
  download_twin_app_cta: "Download Twin App Clicked",
  calendly_date_time_selected: "Scheduled Appointment Date Time Selected",
  thank_you_page_viewed: "Thank You Page Viewed",
  pop_up_triggered: "Pop Up Triggered",
  pop_up_closed: "Pop Up Closed",
  nav_link_clicked: "Navigation Link Clicked",
  social_icon_clicked: "Social Icon Clicked",
  store_cta_clicked: "App/Play Store CTA Clicked",
  legal_link_clicked: "Legal Link Clicked",
  logo_clicked: "Twin Health Logo Clicked",
  faq_clicked: "FAQ Clicked",
  pop_up_shown: "Pop Up Shown",
  resource_cta_clicked: "Resource CTA Clicked",
};
